import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import StoreListPage from "./pages/StoreListPage";
import StorePage from "./pages/StorePage";
import LoginPage from "./pages/LoginPage";
import PrivateRoute from "./PrivateRoute";
import FeedbackPage from "./pages/FeedbackPage";
import WildCardRoute from "./WildCardRoute";
import LkPage from "./pages/LkPage";
import RegPage from "./pages/RegPage";
import ManagementPage from "./pages/ManagementPage";
import QuestionsPage from "./pages/QuestionsPage";
import { MarketplaceProvider, useMarketplace } from "./contexts/MarketplaceContext";

function AppContent() {
  const { currentMarketplace } = useMarketplace();

  useEffect(() => {
    document.body.setAttribute('data-marketplace', currentMarketplace);
  }, [currentMarketplace]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route path="registration" element={<RegPage />} />
        <Route path="*" element={<WildCardRoute />} />
        <Route
          path="stores/:id"
          element={<PrivateRoute element={<StorePage />} />}
        />
        <Route
          path="stores"
          element={<PrivateRoute element={<StoreListPage />} />}
        />
        <Route
          path="feedback/unanswered"
          element={<PrivateRoute element={<FeedbackPage />} />}
        />
        <Route
          path="questions/unanswered"
          element={<PrivateRoute element={<QuestionsPage />} />}
        />
        <Route path="lk" element={<PrivateRoute element={<LkPage />} />} />
        <Route
          path="management"
          element={<PrivateRoute element={<ManagementPage />} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <MarketplaceProvider>
      <AppContent />
    </MarketplaceProvider>
  );
}

export default App;
